import { LitElement } from 'lit';
import { property, state } from 'lit/decorators.js';
import { userAreaStyles } from './user-area.styles';
import { userAreaTemplate } from './user-area.template';
import { utilSheet } from '../../../shared/utils/styles/utils.styles';

/** Ítems del menú autenticado */
export type AuthItem = { id: string; label: string, url?: string };

export class UserArea extends LitElement {
  static styles = [userAreaStyles, utilSheet];

  /** ¿Usuario autenticado? */
  @property({ type: Boolean, reflect: true }) authenticated = false;

  /** Nombre visible (para iniciales y texto) */
  @property({ type: String, attribute: 'user-name' }) userName = '';

  /** Ítems opcionales del menú autenticado (por defecto solo "Cerrar sesión") */
  @property({ attribute: false }) authItems?: AuthItem[];

  /** Estado del dropdown */
  @state() open = false;

  /** Iniciales derivadas del nombre */
  get initials(): string {
    const safe = (this.userName ?? '').trim().replace(/\s+/g, ' ');
    if (!safe) return 'U';
    const parts = safe.split(' ');
    return parts.slice(0, Math.min(parts.length, 2))
      .map(p => p[0]!.toUpperCase())
      .join('');
  }

  connectedCallback(): void {
    super.connectedCallback();
    this._onDocClick = this._onDocClick.bind(this);
    this._onKey = this._onKey.bind(this);
    document.addEventListener('click', this._onDocClick);
    document.addEventListener('keydown', this._onKey);
  }
  disconnectedCallback(): void {
    document.removeEventListener('click', this._onDocClick);
    document.removeEventListener('keydown', this._onKey);
    super.disconnectedCallback();
  }

  private _onDocClick(e: MouseEvent) {
    if (!this.open) return;
    if (!e.composedPath().includes(this)) this.open = false;
  }
  private _onKey(e: KeyboardEvent) {
    if (e.key === 'Escape') this.open = false;
  }

  _toggle() { this.open = !this.open; }


  _select(id: AuthItem) {
    this.open = false;
    this.dispatchEvent(new CustomEvent('user-select', {
      bubbles: true, composed: true, detail: id
    }));
  }

  render() {
    return userAreaTemplate(this);
  }
}

customElements.define('mm-user-area', UserArea);
